// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-segment {
  display: none;
}
ion-segment.display {
  display: -webkit-box;
}
ion-segment {
  height: 28px;
  --margin-top: 0;
}
ion-segment ion-segment-button {
  margin: 0;
  min-height: 18px;
}

ion-icon {
  margin: 0;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/result-layout-toggle/result-layout-toggle.component.scss"],"names":[],"mappings":"AACA;EACC,aAAA;AAAD;AACC;EACC,oBAAA;AACF;AAJA;EAKC,YAAA;EACA,eAAA;AAED;AADC;EACC,SAAA;EACA,gBAAA;AAGF;;AAAA;EACC,SAAA;EACA,eAAA;AAGD","sourcesContent":["\r\nion-segment {\r\n\tdisplay:none;\r\n\t&.display {\r\n\t\tdisplay:-webkit-box;\r\n\t}\r\n\theight: 28px;\r\n\t--margin-top: 0;\r\n\tion-segment-button {\r\n\t\tmargin: 0;\r\n\t\tmin-height: 18px;\r\n\t}\r\n}\r\nion-icon {\r\n\tmargin: 0;\r\n\tfont-size: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
